/**
 * Mirrors Backend models/meditation_sessions.model.js MEDITATION_SESSION_TYPES.
 * null = unclassified (not inferred from title/category).
 */
export const MEDITATION_SESSION_TYPES = ['pranayama', 'mantra', 'dhyan'];

export const SESSION_TYPE_LABELS = {
  pranayama: 'Pranayama',
  mantra: 'Mantra',
  dhyan: 'Dhyan',
};

/** Badge mapping for Admin helper copy (classification only — not direct award). */
export const SESSION_TYPE_ACHIEVEMENT_MAP = {
  pranayama: 'The Breath',
  mantra: 'The Sound',
  dhyan: 'The Still',
};
